module.exports = __webpack_public_path__ + "media/images/emblems/Saignelegier-armoiries-732479fb328ff458cff985dee8f61bd5.svg";